import React, { useCallback, useContext } from 'react';
import { Clickable } from 'src/components/clickable';
import { AppContext } from 'src/components/app-context';
import { CardActionArea } from '@prisjakt/ui/card';
import { BaseProps } from '../../types';
import { ActionButton, Card } from './styles';

type Props = Pick<
  BaseProps,
  | 'link'
  | 'className'
  | 'container'
  | 'background'
  | 'selected'
  | 'selectable'
  | 'onClick'
  | 'onDeselect'
  | 'onSelect'
  | 'buttonAriaLabel'
  | 'ActionArea'
  | 'FooterArea'
  | 'isClickable'
> & {
  outlined?: boolean;
};

export const GridCard: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<Props>
>> = props => {
  const { renderMode } = useContext(AppContext);

  const {
    buttonAriaLabel,
    background,
    children,
    className,
    link,
    onClick,
    onDeselect = () => {},
    onSelect = () => {},
    selectable,
    selected,
    ActionArea = null,
    FooterArea = null,
    isClickable = true,
    outlined = true,
  } = props;

  const onClickOrSelect = useCallback(() => {
    const handleSelect = () => {
      if (selected) {
        onDeselect();
      } else {
        onSelect();
      }
    };

    if (selectable) handleSelect();
    else if (onClick) onClick();
  }, [selected, onDeselect, onSelect, selectable, onClick]);

  return (
    <Card
      className={className}
      background={background}
      outlined={outlined}
      selected={selected}
      container={'article' as any}
      containerProps={{ 'data-test': 'ProductGridCard' }}
    >
      {ActionArea && <ActionButton>{ActionArea}</ActionButton>}

      {isClickable ? (
        <CardActionArea
          container={Clickable}
          containerProps={{
            to: selectable ? undefined : link,
            'aria-label': buttonAriaLabel,
            isExternal: renderMode === 'native',
            onClick: onClickOrSelect,
            style: { flex: '1 1 auto', cursor: 'pointer' },
          }}
        >
          {children}
        </CardActionArea>
      ) : (
        children
      )}

      {FooterArea}
    </Card>
  );
};
